// Suffixes " (2)", " (3)", ... until the name doesn't collide (case-insensitively) with an
// existing artifact name — mirrors the backend's case-insensitive duplicate-name rejection.
export const buildUniqueArtifactName = (baseName: string, existingNames: string[]): string => {
	const taken = new Set(existingNames.map((name) => name.trim().toLowerCase()));
	if (!taken.has(baseName.trim().toLowerCase())) return baseName;

	let suffix = 2;
	while (taken.has(`${baseName} (${suffix})`.trim().toLowerCase())) suffix += 1;
	return `${baseName} (${suffix})`;
};

export default buildUniqueArtifactName;
